import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoAudiencia, TipoAudienciaProps } from '../../interfaces/catalogos/TipoAudienciaInterface';

export const TipoAudiencias = () => {

    return new Promise<TipoAudienciaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoAudiencia/', token)
            .then( ({ data } : { data : TipoAudienciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoAudiencias = () => {

    return new Promise<TipoAudienciaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoAudiencia/ObtenerTipoAudiencias', token)
            .then( ({ data } : { data : TipoAudienciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoAudiencia = ( params: TipoAudienciaProps ) => {

    return new Promise<TipoAudienciaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoAudiencia/Actualizar', params, token)
            .then( ({ data } : { data : TipoAudienciaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoAudiencia });
            });

        }

    });

}

export const AgregarTipoAudiencia = ( params: TipoAudienciaProps ) => {

    return new Promise<TipoAudienciaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoAudiencia/Agregar', params, token)
            .then( ({ data } : { data : TipoAudienciaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoAudiencia });
            });

        }

    });

}
